// components
import { LAYOUT_DEFAULT } from "../components/layouts";

export default function PAGE_ADMIN_USERS () {
    return (
        <LAYOUT_DEFAULT pageName={ "admin_users" }>
            <section>Admin Users</section>
        </LAYOUT_DEFAULT>
    )
}